import { useSyncExternalStore } from 'react';

interface EditorUiState {
  previewDragging: boolean;
  setPreviewDragging: (next: boolean) => void;
}

let currentState: Omit<EditorUiState, 'setPreviewDragging'> = {
  previewDragging: false
};

const listeners = new Set<() => void>();

const getSnapshot = () => currentState;

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

const setPreviewDraggingInternal = (next: boolean) => {
  if (currentState.previewDragging === next) return;
  currentState = { ...currentState, previewDragging: next };
  for (const l of listeners) l();
};

/**
 * Module-federation-safe editor UI store.
 * Uses React's useSyncExternalStore instead of Zustand so the remote shares the host React instance.
 */
export const useEditorUiStore = () => {
  const snapshot = useSyncExternalStore(subscribe, getSnapshot);
  return {
    previewDragging: snapshot.previewDragging,
    setPreviewDragging: setPreviewDraggingInternal
  } satisfies EditorUiState;
};
